import React, { useState } from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'stores';
import Loading from 'components/Loading';
import { FormCard } from 'components/Card';
import { ErrorMessage } from 'components/Message';

import { CreateForm, UserInputDictionary } from './CreateForm';

export const Page: React.FC = observer(() =>
{
  const { uiStore, featureStore } = useStore();
  const [userInput, setUserInput] = useState<UserInputDictionary>({});

  return (
    <article className="page feature-create">
      <FormCard>
      {
        featureStore.isLoading
        ? <><h1>{uiStore.labels.common.loading}</h1><Loading /></>
        : <>
            <h1>{uiStore.labels.pages.features.pages.featureCreate.title}</h1>
            {featureStore.errorMessage ? <ErrorMessage>{featureStore.errorMessage}</ErrorMessage> : null}
            <CreateForm userInput={userInput} saveUserInput={(input: UserInputDictionary) => setUserInput(prev => input)} />
          </>
      }
      </FormCard>
    </article>
  );
});